// src/utils/favicon.js
export const updateFavicon = (faviconUrl) => {
  if (!faviconUrl) return;

  // Find existing favicon link
  let link =
    document.getElementById("favicon") ||
    document.querySelector("link[rel*='icon']");

  if (!link) {
    // Create new link if doesn't exist
    link = document.createElement("link");
    link.id = "favicon";
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.href = faviconUrl;
};

export const updatePageTitle = (orgName, pageName = "Survey Dashboard") => {
  if (orgName) {
    document.title = `${orgName} - ${pageName}`;
  } else {
    document.title = pageName;
  }
};
